import React from 'react';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <section className="py-10 md:py-14 px-4 md:px-8 bg-navy-dark relative overflow-hidden" data-id="element-208">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-209"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-211">
          <h3 className="text-3xl md:text-5xl font-headline font-extrabold text-white mb-6" data-id="element-212">
            Una Inversión Que Se Paga Sola En La Primera Semana
          </h3>
          <p className="text-lg text-body font-body max-w-2xl mx-auto" data-id="element-213">
            El valor total de esta transformación es de{' '}
            <strong className="text-white font-headline font-bold" data-id="element-214">
              $37 USD.
            </strong>
            <br data-id="element-215" />
            <br data-id="element-216" />
            Pero porque creemos que el cambio financiero real debe ser accesible
            para quienes están listos para actuar, hoy puedes asegurar tu
            transformación por una única inversión de:
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-midnight border border-gold/40 rounded-2xl overflow-hidden max-w-2xl mx-auto mb-12 shadow-gold" data-id="element-217">
          <div className="flex flex-col md:flex-row border-b border-gold-separator/20" data-id="element-218">
            <div className="p-6 md:w-1/2 bg-navy-dark/50 flex items-center" data-id="element-219">
              <span className="text-body font-headline font-semibold" data-id="element-220">
                Valor real del sistema
              </span>
            </div>
            <div className="p-6 md:w-1/2 flex items-center justify-end" data-id="element-221">
              <span className="text-2xl text-body line-through font-bold opacity-80" data-id="element-222">
                $37 USD
              </span>
            </div>
          </div>

          <div className="flex flex-col md:flex-row border-b border-gold-separator/20 bg-gold/10" data-id="element-223">
            <div className="p-6 md:w-1/2 flex items-center gap-3" data-id="element-224">
              <span className="text-gold font-headline font-bold text-xl" data-id="element-225">
                Tu inversión hoy
              </span>
              <span className="inline-block bg-gold-badge text-gold-light text-xs font-headline font-bold px-3 py-1 rounded-full border border-gold/30" data-id="element-226">
                83% OFF
              </span>
            </div>
            <div className="p-6 md:w-1/2 flex items-center justify-end" data-id="element-227">
              <span className="text-4xl md:text-5xl text-gold font-headline font-extrabold" data-id="element-228">
                $6.36 USD
              </span>
            </div>
          </div>

          <div className="flex flex-col md:flex-row" data-id="element-229">
            <div className="p-6 md:w-1/2 bg-navy-dark/50 flex items-center" data-id="element-230">
              <span className="text-body font-headline font-semibold" data-id="element-231">
                Lo que obtienes
              </span>
            </div>
            <div className="p-6 md:w-1/2 flex items-center justify-end text-right" data-id="element-232">
              <span className="text-white font-headline font-bold" data-id="element-233">
                Más de 6 veces el valor de tu inversión
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-234">
          <p className="text-xl text-gold-light italic font-serif" data-id="element-235">
            Al precio de un café puedes dejar de perder cientos o miles de
            dólares en ingresos por bloqueos que no ves.
          </p>
        </motion.div>
      </div>
    </section>;
}